import React from 'react';
import { motion } from 'framer-motion';
const TARGET_IMAGE = 'https://cdn.magicpatterns.com/uploads/d9MP4jEYxHQeWoY9z3yzp5/Diseno_sin_titulo_(15).png';
export function TargetAudienceSection() {
  return <section className="w-full bg-white p-0 m-0 leading-[0]" data-id="element-319">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="w-full" data-id="element-320">
        <img src={TARGET_IMAGE} alt="Esto es para ti si..." className="w-full h-auto block m-0 p-0" data-id="element-321" />
      </motion.div>
    </section>;
}